import moment, { MomentInput } from 'moment';
import isString from 'lodash/isString';

const util = {
  formatTime(date: string | Date) {
    const newDate = new Date(date);
    const dateHours = `00${newDate.getHours()}`.slice(-2);
    const dateMinutes = `00${newDate.getMinutes()}`.slice(-2);
    return `${dateHours}:${dateMinutes}`;
  },
  formatDecimal(data: number | string) {
    return data.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
  },
  invoiceDateTimeFormatter(
    datetime: MomentInput,
    string: 'date' | 'time' | 'datetime'
  ) {
    if (string === 'date') {
      return moment(datetime).format('DD MMM YYYY');
    }
    if (string === 'time') {
      return moment(datetime).format('HH:mm');
    }
    if (string === 'datetime') {
      return moment(datetime).format('DD MMM YYYY HH:mm');
    }
  },
};

export function formatTime(text: string | Date) {
  return util.formatTime(text);
}

export function formatDecimal(text: number | string) {
  return util.formatDecimal(text);
}

export function currencyFormatter(input: number | string, decimal = 0) {
  if (Number.isNaN(Number(input))) {
    // eslint-disable-next-line no-param-reassign
    input = 0;
  }

  const currency = 'Rp.';
  const number = Math.abs(Number(input)).toFixed(decimal); // remove '-' negative in number
  const [integer, fraction] = number.split('.');

  // creating thousand separator using '.'
  const formattedInteger = integer
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

  // assembling into currency format
  const result = !fraction
    ? `${currency} ${formattedInteger}`
    : `${currency} ${formattedInteger},${fraction}`;

  return input < 0 ? `(${result})` : result;
}

export function numberFormatter(input: number | string, decimal = 0) {
  let result = currencyFormatter(input, decimal);
  result = result.replace('Rp. ', '');

  return result;
}

export function percentWithNegative(text: number | string) {
  if (!text && text !== 0) return '';
  const resultPrice = parseFloat(String(text)).toFixed(0);
  const absPrice = Math.abs(Number(resultPrice));

  if (Number(resultPrice) < 0) {
    return `(${absPrice}%)`;
  }

  return `${absPrice}%`;
}

export function rupiahWithNegativeWithoutBracket(text: number | string) {
  return (!text && text !== 0) || Number.isNaN(Number(text))
    ? ''
    : currencyFormatter(text);
}

export function rupiah(text: number | string) {
  if (!text && text !== 0) return '';

  let result = currencyFormatter(Math.abs(Number(text)));

  if (text < 0) {
    result = result.replace('Rp. ', 'Rp. -');
  }

  return result;
}

export function invoiceReceiptDateTime(
  datetime: MomentInput,
  string: 'date' | 'time' | 'datetime'
) {
  return util.invoiceDateTimeFormatter(datetime, string);
}

export function dateFormatter(datetime: MomentInput, format = 'DD-MM-YYYY') {
  return moment(datetime).format(format);
}

export function limitTo(foo, limit) {
  if (typeof foo === 'string') {
    return foo.substr(0, limit);
  }
  if (Array.isArray(foo)) {
    return foo.slice(0, limit);
  }
  throw new Error(
    `first parameter of 'limitTo' must be string or array, instead get ${JSON.stringify(
      foo
    )}`
  );
}

export function phoneNumberFormatter(phone: unknown) {
  if (!isString(phone)) {
    return '';
  }

  let phoneNumber = phone.replace(/-/g, '');
  let phoneNumberFormatted: string;

  phoneNumber = phoneNumber.replace(/\+/g, '');

  if (phoneNumber.match(/^62/)) {
    phoneNumberFormatted = phoneNumber.replace(/^62/, '');
  } else if (phoneNumber.match(/^0/)) {
    phoneNumberFormatted = phoneNumber.replace(/^0/, '');
  } else {
    phoneNumberFormatted = phoneNumber;
  }

  return phoneNumberFormatted;
}

export function changeRupiahToNegativeFloat(text: string) {
  let stringData = text.replace('Rp. ', '');
  const regex = /\./g;
  let val: string;

  stringData = stringData.replace(regex, '');

  if (stringData.split('(')[1]) {
    val = String(Number(stringData.split('(')[1].split(')')[0]) * -1);
  } else {
    val = stringData;
  }

  return parseFloat(val);
}

export function changeRupiahToStringNum(text: number | string) {
  return Number.isNaN(Number(text)) || text === 0
    ? '(0)'
    : currencyFormatter(text).replace('Rp. ', '');
}

export function processingErrorMessageImportRecipe(errorList) {
  let rowTitle;
  const parseErrorMessage = errorList.map((item, i) => {
    if (i % 2 === 0) {
      if (item.includes('Row')) {
        const idxSlice = item.indexOf(':');
        rowTitle = item.slice(0, idxSlice + 1);
      } else {
        // eslint-disable-next-line no-param-reassign
        item = rowTitle === undefined ? item : rowTitle + item;
      }
    }
    return item;
  });
  return parseErrorMessage;
}

export function useMokaOutletPropsFirst(outlet, selector) {
  return selector(outlet.moka || outlet);
}

export function randomString(len) {
  let str = '';
  while (str.length < len) {
    str += Math.random().toString(36).substr(2);
  }
  return str.substr(0, len);
}
